module.exports = __webpack_public_path__ + "static/headerimg-4fc2b0c80639605d4fc607602b38a17b.png";